import React from "react";
import { createColumnHelper } from "@tanstack/react-table";
import { renderValue } from "utils/renderCompanyCell";
import StatusPillButtons from "components/Buttons/StatusPillButtons";

const marketerColumns = () => {
  const columnHelper = createColumnHelper();

  return [
    columnHelper.accessor("name", {
      header: "Name",
      size: 283,
      headerClassName: "table-header",
      cellClassName: "table-cell",
      enableSorting: false,
      cell: (info) => {
        const name = info.getValue();
        return <>{renderValue(name)}</>;
      }
    }),
    columnHelper.accessor("email", {
      header: "Email",
      size: 283,
      headerClassName: "table-header",
      cellClassName: "table-cell",
      enableSorting: false,
      cell: (info) => <>{renderValue(info.getValue())}</>
    }),
    columnHelper.accessor("phone_number", {
      header: "Phone",
      size: 283,
      headerClassName: "table-header",
      cellClassName: "table-cell",
      enableSorting: false,
      cell: (info) => <>{renderValue(info.getValue())}</>
    }),
    columnHelper.accessor("status", {
      header: "Status",
      size: 160,
      headerClassName: "table-header",
      cellClassName: "table-cell",
      enableSorting: false,
      cell: (info) => {
        const value = info.getValue();
        return <StatusPillButtons status={value} dot={false} />;
      }
    })
  ];
};

export default marketerColumns;
